import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { getProductsHealth } from "@/services/products";

/**
 * PRODHEALTH · 首页待办「N 个上架产品无法成单」（示意图③）。
 *
 * 照 pages/orders/RoomingListReminder.tsx 的既有 pattern 写：独立 useQuery、
 * 无待办时 render null（不占版面·不改首页 canvas 基线）。
 *
 * 🔴 给所有人看，不做角色分层——用户 2026-08-03 拍板："默认给全部人都可以看，
 * 没有必要再做分层"，别自作主张加权限门（工单 §2.3）。
 */
function healthWindow(): { from: string; to: string } {
  const today = new Date();
  const to = new Date(today);
  to.setDate(to.getDate() + 90);
  return { from: today.toISOString().slice(0, 10), to: to.toISOString().slice(0, 10) };
}

export function ProductHealthReminder() {
  const { from, to } = healthWindow();

  // 🔴 queryKey 必须含 only_problems——跟列表页的全量查询（false）用同一个 key 会被
  // React Query 按 key 去重复用缓存，两边 only_problems 参数不同但结果被错误共享
  // （曾经真的这样漂移过：本组件 true 的结果被列表页当成"全量"用，ok 产品全变"未体检"）。
  const healthQ = useQuery({
    queryKey: ["products", "health", "only-problems", from, to],
    queryFn: () => getProductsHealth(from, to, true),
    staleTime: 60_000,
  });

  const blockedCount = (healthQ.data?.items ?? []).filter((h) => h.verdict === "blocked").length;

  // 无待办 → 不渲染（首页 canvas 基线不受影响，同 RoomingListReminder 口径）
  if (healthQ.isLoading || blockedCount === 0) return null;

  return (
    <Link
      to="/products?sellable=blocked"
      className="flex items-center gap-3 rounded-xl border border-rose-300 bg-rose-50 px-4 py-3 transition hover:bg-rose-100/70"
    >
      <span className="text-[26px] font-bold leading-none text-rose-600">{blockedCount}</span>
      <div className="min-w-0 flex-1">
        <p className="text-[13px] font-bold text-slate-900">个上架产品无法成单</p>
        <p className="truncate text-[11px] text-slate-500">资源配置缺失 · 同行能下单但确认会失败</p>
      </div>
      <span className="shrink-0 text-[12px] font-medium text-rose-600">去处理 →</span>
    </Link>
  );
}
